import { initializeApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage, connectStorageEmulator } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCGVhedRbKrxDQ-i-SZA1aZylxHLBdY8TQ",
  authDomain: "voice-victor.firebaseapp.com",
  projectId: "voice-victor",
  storageBucket: "voice-victor.firebasestorage.app",
  messagingSenderId: "131385581458",
  appId: "1:131385581458:web:8b56b98b0bbccdcc1b2b4b"
};

// Log firebaseConfig for debugging
console.error("DEBUG: Firebase config:", {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  storageBucket: firebaseConfig.storageBucket
});

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Eksporter auth og firestore med eksplicitte typer
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);

// Storage med eksplicit bucket navn (uden gs:// prefix)
export const storage: FirebaseStorage = getStorage(app, 'voice-victor.firebasestorage.app');

// Tjek om vi bruger localhost
if (window.location.hostname === 'localhost') {
  console.error("DEBUG: Kører på localhost");
  
  // Ukommenter denne linje hvis du bruger Firestore emulator
  // connectFirestoreEmulator(db, 'localhost', 8080);
}

console.error('DEBUG: Firebase initialiseret med projektid:', firebaseConfig.projectId);
console.error('DEBUG: Firebase Storage bucket:', firebaseConfig.storageBucket);

export default app; 